import { render, staticRenderFns } from "./PlotChangePage.vue?vue&type=template&id=2ebb9f77"
import script from "./PlotChangePage.vue?vue&type=script&lang=ts"
export * from "./PlotChangePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ebb9f77')) {
      api.createRecord('2ebb9f77', component.options)
    } else {
      api.reload('2ebb9f77', component.options)
    }
    module.hot.accept("./PlotChangePage.vue?vue&type=template&id=2ebb9f77", function () {
      api.rerender('2ebb9f77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/PlotChangePage.vue"
export default component.exports